import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className='footer'>
      <div className='footerContent'>
        <div className='footerLogo'>ICE GEMS, Inc.</div>
        <a href="mailto:Contact@IceGems.com" className='footerEmail'>Contact@IceGems.com</a>
        <a href="tel:4132404326" className='footerPhone'>(413)-240-4326</a>
        <div className='socialMedia'>
          <a href='https://www.youtube.com/channel/UCgubB1wK55iyCO0qTlQ22Yg'>
            <FontAwesomeIcon icon={faYoutube} size='2x' />
          </a>

          <a href='https://www.linkedin.com/company/ice-gems-inc/'>
            <FontAwesomeIcon icon={faLinkedin} size='2x' />
          </a>
        </div>
        <Link to="/contact" className='footerInfo'>Contact</Link>
        <p className='disclaimer'>ALL RIGHTS RESERVED © ICE GEMS, Inc.  {currentYear}</p>
      </div>
    </footer>
  );
};

export default Footer;